/// <amd-module name="VSSUI/Components/Menu/ContextMenuBehavior" />
import * as React from "react";
import { IBehavior } from "VSSUI/Utilities/Behavior";
import { IEventDispatch } from "VSSUI/Utilities/Dispatch";

export class ContextMenuBehavior implements IBehavior<{}, {}> {
    private contextMenuHandler: (event: React.MouseEvent<HTMLElement, MouseEvent> | React.KeyboardEvent<HTMLElement>) => void;
    private eventDispatch: IEventDispatch;
    private allowDefaultMenuOnAnchor: boolean;

    constructor(contextMenuHandler: (event: React.MouseEvent<HTMLElement, MouseEvent> | React.KeyboardEvent<HTMLElement>) => void, allowDefaultMenuOnAnchor: boolean = false) {
        this.contextMenuHandler = contextMenuHandler;
        this.allowDefaultMenuOnAnchor = allowDefaultMenuOnAnchor;
    }

    public initialize = (props: any, component: any, eventDispatch: IEventDispatch) => {
        this.eventDispatch = eventDispatch;
        this.eventDispatch.addEventListener("contextmenu", this.onContextMenu);
    };

    private onContextMenu = (event: React.MouseEvent<HTMLElement, MouseEvent> | React.KeyboardEvent<HTMLElement>) => {
        if (this.allowDefaultMenuOnAnchor) {
            // We don't want to show the custom contextual menu and prevent default
            // if user clicked mouse and the target element is an anchor tag.
            if (event.nativeEvent instanceof MouseEvent) {
                const target = event.nativeEvent.target as HTMLElement;
                if (target && target.nodeName === "A") {
                    return;
                }
            }
        }
        this.contextMenuHandler(event);
    };

    public componentWillUnmount() {
        this.eventDispatch?.removeEventListener("contextmenu", this.onContextMenu);
    }
}
